"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spanishNumbers = exports.englishNumbers = void 0;
var englishNumbers = {
  1: 'one',
  2: 'two',
  3: 'three',
  4: 'four',
  5: 'five',
  6: 'six',
  7: 'seven',
  8: 'eight',
  9: 'nine'
};
exports.englishNumbers = englishNumbers;
var spanishNumbers = {
  1: 'uno',
  2: 'dos',
  3: 'tres',
  4: 'cuatro',
  5: 'cinco',
  6: 'seis',
  7: 'siete',
  8: 'ocho',
  9: 'nueve'
};
exports.spanishNumbers = spanishNumbers;